<!-- <a
  class="text-blueGray-500 block"
  href="#pablo"
  (click)="toggleDropdown($event)"
  #btnDropdownRef
>
  <div class="items-center flex">
    <span
      class="w-12 h-12 text-sm text-white bg-blueGray-200 inline-flex items-center justify-center rounded-full"
    >
      <img
        alt="..."
        class="w-full rounded-full align-middle border-none shadow-lg"
        src="assets/img/team-1-800x800.jpg"
      />
    </span>
  </div>
</a>
<div class="min-w-48 z-50" #popoverDropdownRef>
  <div
    class="bg-white text-base z-50 float-left py-2 list-none text-left rounded shadow-lg mt-1 min-w-48"
    [ngClass]="dropdownPopoverShow ? 'block' : 'hidden'"
  >
    <a
      href="#pablo"
      class="text-sm py-2 px-4 font-normal block w-full whitespace-nowrap bg-transparent text-blueGray-700"
    >
      Action
    </a>
    <a
      href="#pablo"
      class="text-sm py-2 px-4 font-normal block w-full whitespace-nowrap bg-transparent text-blueGray-700"
    >
      Another action
    </a>
    <a
      href="#pablo"
      class="text-sm py-2 px-4 font-normal block w-full whitespace-nowrap bg-transparent text-blueGray-700"
    >
      Something else here
    </a>
    <div class="h-0 my-2 border border-solid border-blueGray-100"></div>
    <a
      href="#pablo"
      class="text-sm py-2 px-4 font-normal block w-full whitespace-nowrap bg-transparent text-blueGray-700"
    >
      Seprated link
    </a>
  </div>
</div> -->




<a class="text-blueGray-500 block cursor-pointer" (click)="toggleDropdown($event)" #btnDropdownRef>
  <div class="items-center flex px-4">
    <span class="w-12 h-12 text-sm text-white bg-blueGray-200 inline-flex items-center justify-center rounded-full">
      <img alt="..." class="w-full rounded-full align-middle border-none shadow-lg"
        src="assets/img/default-profile.png" />
    </span>
  </div>
</a>
<div class=" min-w-48 z-50" #popoverDropdownRef>
  <div class="bg-white text-base z-50 float-left py-2 list-none rounded shadow-lg mt-2 min-w-48"
    [ngClass]="dropdownPopoverShow ? 'block' : 'hidden'">
    <a (click)="checkAuth()"
      class="text-base font-bold py-2 px-4 flex w-full text-gray-500 hover:bg-primary-light cursor-pointer">
      <img class="px-1 w-8" src="../../../assets/img/icon/User_outline.svg" alt="">
      حساب کاربری
    </a>
    <div class="h-0 my-2 border border-solid border-blueGray-100"></div>
    <a (click)="modal.open()"
      class="text-base py-2 px-4 font-bold flex w-full cursor-pointer text-gray-500 hover:bg-primary-light">
      <img class="px-1 w-8" src="../../../assets/img/icon/Logout_outline.svg" alt="">
      خروج
    </a>
    <!-- <div class="h-0 my-2 border border-solid border-blueGray-100"></div>
    <a (click)="test()"
      class="text-base py-2 px-4 font-bold flex w-full whitespace-nowrap bg-transparent text-gray-500 hover:bg-primary-light">
      <img class="px-1 w-8" src="../../../assets/img/icon/Logout_outline.svg" alt="">
      test
    </a> -->
  </div>
</div>


<app-modal #modal>
  <!--header-->
  <div class="flex items-start justify-between p-2 border-b border-solid border-blueGray-200 rounded-t">
    <h3 class="text-2xl font-semibold">
      خروج
    </h3>
    <button
      class="p-1 bg-transparent border-0 text-black opacity-5 float-right text-3xl leading-none font-semibold outline-none focus:outline-none"
      (click)="modal.close()">
      <span class="bg-transparent text-black opacity-5 h-6 w-6 text-2xl block outline-none focus:outline-none">
        ×
      </span>
    </button>
  </div>
  <!--body-->
  <div class="relative py-4 flex-auto md:me-32">
    <p class="mt-4 mb-12 text-blueGray-500 text-base text-start leading-relaxed">
      آیا قصد دارید از سایت خارج شوید؟
    </p>
  </div>
  <!--footer-->
  <div class="flex items-center justify-between py-2 border-solid border-blueGray-200 rounded-b">
    <button
      class="text-red-500 border-red-500 background-transparent font-bold px-6 py-2 rounded text-sm my-2 ease-linear transition-all duration-150"
      type="button" (click)="modal.close()">
      انصراف
    </button>
    <button
      class="bg-red-500 text-white active:bg-red-500 font-bold text-sm px-6 py-2 rounded shadow hover:shadow-lg my-2 ease-linear transition-all duration-150"
      type="button" (click)="logout()">
      خروج
    </button>
  </div>
</app-modal>